<template lang="pug">
  div.recently-hot-case
    div.component-title 近期热点危机
    div.list(v-for="(list, i) in lists" :key="i")
      div.logo
        img(:src="list.imgUrl" @error="defaultImg")
      div.details
        div.title
          router-link(:to="{name: 'EventGeneral', params: {id: list.id}}" target="_blank") {{list.eventName}}
        div.startTime {{list.startTime}}
        div.tags
          div.tag.brand {{list.brand}}
          div.tag.category {{list.category}}
</template>

<script>
import client from '../server/server'
import moment from 'moment'
export default {
  name: 'RecentlyHotCase',
  data () {
    return {
      lists: []
    }
  },
  mounted () {
    this.getTop5()
  },
  methods: {
    getTop5 () {
      client.getOnlineTop5().then(res => {
        if (res.success) {
          this.lists = res.data.map(d => {
            return Object.assign({}, d, {
              imgUrl: this.$imgParse(d.imgUrl),
              startTime: moment(d.startTime).format('YYYY/MM/DD')
            })
          })
        }
      })
    },
    defaultImg (e) {
      e.target.src = require('@index/assets/img/event_default.png')
    }
  }
}
</script>

<style lang="scss" scoped>
.recently-hot-case {
  width: 320px;
  height: 100%;
  background-color: #ffffff;
  border-radius: 4px;
  margin-left: 20px;
  padding: 24px;
  overflow-y: auto;
  .component-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }
  .list {
    min-height: 110px;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    .logo {
      margin: 20px 10px 0 0;
      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: 1px solid #ddd;
      }
    }
    .details {
      font-size: 12px;
      .title {
        margin-top: 10px;
        color: #666;
      }
      .startTime {
        color: #999;
        margin-top: 10px;
      }
      .tags {
        display: flex;
        align-items: center;
        margin-top: 10px;
        .tag {
          padding: 3px 6px;
          border-radius: 2px;
          &.brand {
            background-color: #fef1ed;
            color: #f87653;
            border: solid 1px #f87653;
            margin-right: 10px;
          }
          &.category {
            background-color: #ebf3fa;
            color: #3989cb;
            border: solid 1px #3989cb;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventSearch/RecentlyHotCase.vue